import React from "react";
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import { Col, Container, Row } from "react-bootstrap"
import { FaChevronRight, FaChevronLeft } from "react-icons/fa6"
import { AnimationOnScroll } from 'react-animation-on-scroll'

import image_1 from '../assets/banner/banner1.png'
import image_2 from '../assets/banner/banner2.png'
import image_3 from '../assets/banner/banner3.png'
import image_4 from '../assets/banner/banner4.png'

// Custom panah kanan
const NextArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className="banner-arrow-right"
  >
   <FaChevronRight size={30}/>
  </div>
);

// Custom panah kiri
const PrevArrow = ({ onClick }) => (
  <div
    onClick={onClick}
    className="banner-arrow-left"
  >
    <FaChevronLeft size={30}/>
  </div>
);

function Banner() {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrow: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  }

  return (
    <div className="banner-container">
      <Slider {...settings}>
        <div className="pt-5 pb-5">
          <Container>
            <Row className="align-items-center">
              <Col md={6} xs={12} className="mt-3">
                <AnimationOnScroll animateOnce={true} animateIn="animate__fadeIn" duration={.8} animatePreScroll={true} offset={0}>
                  <div className="banner-header text-center-mobile"><span className="text-brand-secondary">81% of Organizations</span> Have Unsecured Public Assets. The Question isn't <span className="text-brand-secondary">IF You'll Be Targeted</span>, but <span className="text-brand-secondary">WHEN.</span></div>
                  <div className="banner-info mt-3 text-center-mobile">Most companies don’t realize they’re exposed until it's too late.</div>
                </AnimationOnScroll>
              </Col>
              <Col md={1}/>
              <Col md={5} xs={12} className="mt-3 text-center-mobile">
                <AnimationOnScroll animateOnce={true} animateIn="animate__slideInRight" duration={.8} animatePreScroll={true} offset={0}>
                  <img src={image_1} alt=""/>
                </AnimationOnScroll>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="pt-5 pb-5">
          <Container>
            <Row className="align-items-center">
              <Col md={6} xs={12} className="mt-3">
                <div className="banner-header text-center-mobile"><span className="text-brand-secondary">Misconfigured Cloud Environments</span> are the New Open Doors. How <span className="text-brand-secondary">Exposed</span> is <span className="text-brand-secondary">Your Organization</span> Right Now?</div>
                <div className="banner-info mt-3 text-center-mobile">Simple misconfigurations can open your entire cloud to attackers.</div>
              </Col>
              <Col md={1}/>
              <Col md={5} xs={12} className="mt-3 text-center-mobile">
                <img src={image_2} alt=""/>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="pt-5 pb-5">
          <Container>
            <Row className="align-items-center">
              <Col md={6} xs={12} className="mt-3">
                <div className="banner-header text-center-mobile">Our Cloud Security Solution <span className="text-brand-secondary">Eliminates Blind Spots</span> Across Your Cloud Environment. <span className="text-brand-secondary">No Agents, No Complexity, No Compromise.</span></div>
                <div className="banner-info mt-3 text-center-mobile">One platform to secure everything without slowing you down.</div>
              </Col>
              <Col md={1}/>
              <Col md={5} xs={12} className="mt-3 text-center-mobile">
                <img src={image_3} alt=""/>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="pt-5 pb-5">
          <Container>
            <Row className="align-items-center">
              <Col md={6} xs={12} className="mt-3">
                <div className="banner-header text-center-mobile"><span className="text-brand-secondary">Agentless by Design</span>, Comprehensive by Nature. See <span className="text-brand-secondary">Every Cloud Risk</span> Without the <span className="text-brand-secondary">Overhead</span>.</div>
                <div className="banner-info mt-3 text-center-mobile">Gain complete visibility across your cloud — instantly and effortlessly.</div>
              </Col>
              <Col md={1}/>
              <Col md={5} xs={12} className="mt-3 text-center-mobile">
                <img src={image_4} alt=""/>
              </Col>
            </Row>
          </Container>
        </div>
      </Slider>
    </div>
  );
}

export default Banner;